(ns motorsaif.web.admin.contextual-info
  (:require
   [motorsaif.time :as time]
   [re-frame.core :as rf]
   [motorsaif.string :refer [format]]
   [motorsaif.request-utils :as ru]
   [reagent.core :as r]
   [reagent.ratom :as ra]))

;; Available info on request page:
;; Request information, user information
;; Business information if posted by buinsess


;; (rf/subscribe [:businesses])


(defn user-webpush [{:keys [webpush-clients business-id role-id request-id]}]
  (let [*expanded (r/atom false)]
    (fn []
      [:li
       [:button.biz-name.reset-button
        {:on-click #(swap! *expanded not)}
        (format "Webpush-clients (%s)" (count webpush-clients))]
       (when @*expanded
         (into [:ol]
               (map (fn [{id :id client :client/ua sent :sent}]
                      [:li
                       [:span.title (format "%s %s" id client)]
                       [:span.val sent]
                       [:span.action
                        [:button.btn.primary.small
                         {:type "button"
                          :on-click #(rf/dispatch [:admin/send-request-notification
                                                   {:request-id request-id
                                                    :webpush-id id
                                                    :business-id business-id
                                                    :type :webpush}])}
                         "Send"]]]) webpush-clients)))])))

(defn user-notification-channels
  [{:keys [request-id business-id itm]}]
  (let [*expanded (r/atom true)
        {:keys [user last-email webpush]} itm]
    (fn []
      (let [{user-id :db/id
             :user/keys [email handle]} user]
        [:li.user
         [:button.biz-name.reset-button
          {:on-click #(swap! *expanded not)}
          handle]
         (str itm)
         [:div email]
         (when @*expanded
           [:ul
            [:li
             [:span.title "Email"]
             [:span.val (or last-email "Unsent")]
             [:span.action
              [:button.btn.primary.small
               {:type "button"}
               "Send"]]]
            [user-webpush {:webpush-clients webpush
                           :request-id request-id
                           :business-id business-id}]
            #_[:li
               "Webpush"
               (into [:ol]
                     (map (fn [{id :id client :client/ua sent :sent}]
                            [:li
                             [:span.title client]
                             [:span.val sent]
                             [:span.action
                              [:button.btn.primary.small
                               {:type "button"}
                               "Send"]]
                             ])
                          webpush)
                     )]])]))))

(defn request-matched-business [{:keys [request-id] :as itm}]
  (let [*expanded (r/atom false)]
    (fn [itm]
      (let [{:keys [business last-whatsapp last-email roles]} itm
            {business-id :db/id
             :business/keys [name misc]} business
            {:keys [whatsapp]} misc
            ]
        [:li.biz
         [:button.biz-name.reset-button
          {:on-click #(swap! *expanded not)}
          name]
         (when @*expanded
           [:div.expanded
            ;; [:h5 "Activity"]
            #_[:ul.info
               [:li
                [:span.title "Last Seen"]
                [:span.val (time/date->format (time/date) "dd/MM/yy h:m a")]]
               [:li
                [:span.title "Seen Post"]
                [:span.val (time/date->format (time/date) "dd/MM/yy h:m a")]]
               [:li
                [:span.title "Messages"]
                [:span.val "N/A"]]]

            [:h5 "Notification Channels"]
            [:ul.actions
             [:li
              [:span.title "Business Email"]
              [:span.val
               (or last-email "Unsent")
               [:span.action
                [:button.btn.primary.small
                 {
                  ;; :on-click #(rf/dispatch [:admin/send-request-notification
                  ;;                          {:request-id request-id
                  ;;                           :business-id business-id
                  ;;                           :type :whatsapp
                  ;;                           }
                  ;;                          ])
                  :type "button"}
                 "Send"]]]]

             [:li
              [:span.title "Whatsapp"]
              [:span.val (or (and last-whatsapp (time/date->format last-whatsapp "dd/MM/yy H:m a")) "Unsent")
               [:span.action
                [:button.btn.primary.small
                 {:type "button"
                  :on-click #(rf/dispatch [:admin/send-request-notification
                                           {:request-id request-id
                                            :business-id business-id
                                            :type :whatsapp}])}
                 (format "Send: %s" whatsapp)]]]]

             [:h5 "Users"]
             (into [:ol]
                   (map (fn [itm] [user-notification-channels {:itm itm
                                                               :request-id request-id
                                                               :business-id business-id
                                                               }]) roles))

             ;; (str roles)
             #_[:li
                [:span.title "App Alert"]
                [:span.val "Unsent"
                 [:span.action
                  [:button.btn.primary.small
                   {:type "button"}
                   "Send"]]]]]])]))))

(defn- request->businesses [{:keys [request-id admin-data]}]
  ;; (ru/businesses-matching zhe @(rf/subscribe [:admin-data :businesses]))
  ;; (def zr matched-businesses)
  [:div.admin-request-businesses
   [:h3 "Matched Businesses"]
   (into [:ol.businesses]
         (map (fn [itm]
                [request-matched-business (assoc itm :request-id request-id)])
              (:notifications admin-data)))])

(defn request-page [{id :db/id :as request}]
  (rf/dispatch [:admin/fetch-request-data id])
  (fn []
    [:div.admin-context
     [:h2 "Admin Info"]
     ;; (def bzz @(rf/subscribe [:admin/request-data id]))
     [request->businesses
      {:admin-data @(rf/subscribe [:admin/request-data id])
       :request-id id}
      ]])
  )
(comment
  (rf/dispatch [:admin/fetch-request-data (:db/id request)]))

(defn user-information
  ""
  []
  )



;; (defn floaty-admin-button
;;   "Admin button floats on bottom right. Expands to show contextual actions and debug info"
;;   []
;;   (let [*open (r/atom true)]
;;     (fn []
;;       [:div#floaty-admin-button
;;        [:div.button "Admin"]
;;        (when @*open
;;          [:ul.menu
;;           [:li ""]
;;           [:li "Item2"]
;;           [:li "Item1"]
;;           ;; Menu changes based on current route.
;;           ])])))
